/* eslint-disable */
import Vue from "vue";

var updateText = function (el, binding, vnode) {
    var enableAlphaNumericOnly = binding.value;
    var pattern = /[^A-Za-z0-9 ]/g;
    var match = pattern.test(el.value);
    if (match && enableAlphaNumericOnly) {
        let newValue = el.value.replace(pattern, '');
        el.value = newValue;
    }
};
var timeoutId;
export const AlphaNumericOnly = {

    // // update: function (el, binding, vnode) {
    // //     console.log("update....; ");
    // //     updateText(el, binding, vnode);
    // // },
    inserted: function (el, binding, vnode) {
        //console.log("inserted... ");
        updateText(el, binding, vnode);
    },
    bind: function (el, binding, vnode) {
        var enabled = binding.value;
        if (enabled) {
            el.valueChanged = function (event) {
                updateText(el, binding, vnode);
            };
            document.addEventListener('keyup', el.valueChanged);
        }
    },
    unbind: function (el, binding) {
        var enabled = binding.value;
        if (enabled) {
            document.removeEventListener('keyup', el.valueChanged);
        }
    }

};

Vue.directive('alpha-numeric-only', AlphaNumericOnly);